import { supabase } from "./supabase";
import { effacerMemoire } from "./memoire";

// Efface la copie de la dernière visite AVANT de se déconnecter : si la
// déconnexion échoue (hors ligne), la copie ne doit pas rester.
export function deconnecter() {
  effacerMemoire();
  return supabase.auth.signOut();
}
